export default "__VITE_ASSET__35f1f42b__"